import { get, post, postImg } from "@/util/http"
import ApiContainer from "../url"
const digitalApi = {
  getDigitalList: params => get(ApiContainer.digitalList, params),  //获取数字资源列表信息
  getActivityInfoById: params => get(ApiContainer.getActivityInfoById, params),  //获取活动详情
  signActivity: params => post(ApiContainer.signActivity, params),  //报名活动

}
export default digitalApi